export const colors = {
  sand: '#DECFA6',
}
